import React from "react";

export default function Error({ title, error }) {
    return (
        <div
            style={{
                background: "#fcc",
                border: "1px solid #c00",
                padding: "1rem"
            }}
        >
            <h1 style={{ color: "#c00" }}>{title || error.message}</h1>
            <a href="">try again</a>
            <pre style={{ overflow: "auto", background: "#fdd", padding: "1rem" }}>
                {JSON.stringify(error, null, 2)}
            </pre>
        </div>
    );
}
